var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('SIcon',{staticClass:"info-icon mr-2",attrs:{"width":14,"height":"14","name":`${_vm.isWarning ? 'warning' : 'successfull'}-connection`}}),_c('Row',{staticClass:"message-text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }